<template>
    <div>
        <div id="modalDisplayViewNotification" class="modal" :style="{ display: modalDisplayViewNotification }">
            <div class="row">
                <div class="col-lg-12 col-sm-12 col-xs-12">
                    <div class="modal-content border-left-primary">
                        <div class="modal-header">
                            <h5 class="modal-title" id="newFileLabel">Notificação <small title="Notificação criada nesta data"><span class="badge badge-secondary"><i class="fa fa-clock"></i> {{ created_at }}</span></small></h5>
                            
                            <button type="button" class="close" @click="closeModalViewNotification()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                             <div class="row">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Notificação gerada por</label>
                                    <input type="text" class="form-control" placeholder="" :value="notification_by" disabled>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Título</label>
                                    <input type="text" class="form-control" placeholder="" :value="title" disabled>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-xs-12 col-lg-12">
                                    <label for="">Descrição</label>
                                    <textarea class="form-control" rows="4" disabled :value="description"></textarea>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger"
                                @click="closeModalViewNotification()"><i class="fa fa-times"></i> Fechar</button>
                             <button v-if="!read" type="button" class="btn btn-success"
                                @click="markNotificationRead()">Marcar como lida</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        notification_id: { type: Number},
        modalDisplayViewNotification: { type: String, default: 'block' },
        title: { type: String, default: '' },
        description: { type: String, default: '' },
        notification_created_by: { type: String, default: '' },
        created_at: { type: String, default: '' },
        notification_by: { type: String, default: '' },
        read: { type: Boolean, default: false },
    },
    
    methods: {
        closeModalViewNotification() {
            this.$emit('update:closeModalNotification', 'none');

        },
        
        markNotificationRead() {
            this.$emit('update:markNotificationRead', this.notification_id);

        }
    }
}
</script>

<style>
.modal {
    position: fixed;
    z-index: 1999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #f5f5f5;
    margin: 5% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 50%;
}

.modal-header {
    color: #000;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

</style>